import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box, Link } from '@mui/material';
//
import { useActiveLink } from './useActiveLink';

// ----------------------------------------------------------------------

const NavItem = forwardRef(({ title, path, open, active, subItem, externalLink, ...other }, ref) => {
  const theme = useTheme();

  const { active: isActive } = useActiveLink(path);

  const renderContent = (
    <Box
      ref={ref}
      component="span"
      sx={{
        position: 'relative',
        color: 'text.primary',
        fontWeight: isActive ? 'fontWeightSemiBold' : 'fontWeightMedium',
        ...(subItem && {
          color: 'text.secondary',
        }),
        ...(isActive && {
          color: 'primary.main',
          ...(subItem && {
            color: 'text.primary',
            fontWeight: 'fontWeightSemiBold',
          }),
        }),
      }}
      {...other}
    >
      {title}
    </Box>
  );

  if (externalLink) {
    return (
      <Link href={path} target="_blank" rel="noopener" underline="none">
        {renderContent}
      </Link>
    );
  }

  if (subItem) {
    return renderContent;
  }

  return (
    <Link component={RouterLink} href={path} underline="none">
      {renderContent}
    </Link>
  );
});

NavItem.displayName = 'NavItem';

export default NavItem; 
